import { Link, TopHat, Typography, palette } from "@callcenter/design-system"
import cn from "clsx"
import { t } from "i18next"
import { useUnit } from "effector-react"
import { $whiteLabel } from "@callcenter/white-label"

import { useApiDeprecationBanner } from "./api-deprecation-banner.hooks"

import styles from "./api-deprecation-banner.styles.module.pcss"

export const ApiDeprecationBanner = () => {
  const { brandName } = useUnit($whiteLabel.$whiteLabelSettings)
  const { isVisible, isClosing, handleClose } = useApiDeprecationBanner()

  if (!isVisible) {
    return null
  }

  return (
    <div className={cn(styles.wrapper, { [styles.closing]: isClosing })}>
      <TopHat type="info" onClose={handleClose}>
        <div className={styles.container}>
          <Typography.Body2 color={palette.gray1}>
            {t("component_commonKeys_apiDeprecation_topHatLabel", { brand: brandName })}
          </Typography.Body2>
          <Link href="https://developers.voiso.com/reference/migrating-to-v4" target="_blank" className={styles.link}>
            {t("component_commonKeys_apiDeprecation_migrationGuideLabel")}
          </Link>
        </div>
      </TopHat>
    </div>
  )
}
